import http from '../../services/httpService';
import apiEndpoint from '../../constants/config.json'

//create method create_new_check_out_order

export function fetchOurStory(){

   const fullApiEndpoint = `${apiEndpoint.apiEndpoint}/ourStoryManagement/api/fetch_our_story/`;
    return http.get(fullApiEndpoint);
}